export const osspath = 'https://kindstarbiotech.oss-cn-hangzhou.aliyuncs.com/'

export const appid = 'wx284f6b189496a42e'  //线上

// export const appid = 'wx98ac86bc2a6d30d8' //本地